module.exports = __webpack_public_path__ + "static/media/netflix.a35e0c9e.png";